import { css } from '@emotion/react';

export const layoutStyles = css`
  font-family: "Roboto", sans-serif;
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100vh;
  background-color: #f6f7f9;
`;

export const bodyStyles = css`
  display: flex;
  min-height: 0;
`;

export const childrenStyles = css`
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  padding: 20px 24px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const centeredChildrenStyles = css`
  & > * {
    max-width: 1400px;
    margin-left: auto;
    margin-right: auto;
  }
`;
